import React from 'react';
import PropTypes from 'prop-types';

import makeClassName from 'shared-utils/src/makeClassName';
import createStyle from 'shared-utils/src/createStyle';
import CloseIcon from 'shared-vectors/icons/CloseL';
import trackGTMEvents from 'shared-utils/src/trackGTMEvents/new';
import { Icon } from 'shared-vectors';

import Caret from 'shared-vectors/icons/Caret';

import GridItem from '../../../../GridItem';
import Grid from '../../../../Grid';

import style, { mainCls } from './style';

const useStyles = createStyle(style);

const Header = ({
  activeMedia,
  closeModal,
  slider,
  device,
  uri,
  callOpenSpecificModal,
  loadDetail,
}) => {
  const cls = useStyles();

  const hdrCls = makeClassName([cls[mainCls], 'c-bg--w', 'bb--s', 'is-rel']);

  const closeBtnCls = makeClassName([
    cls[`${mainCls}__btn`],
    cls[`${mainCls}__closebtn`],
    cls[`${mainCls}__h100`],
    'c-txt--f0',
    'is-clickable',
  ]);

  const leadBtnCls = makeClassName([
    cls[`${mainCls}__leadbtn`],
    'c-bg--primary',
    'c-txt--w',
    'tp-w--l',
    'tp-s--m',
    'b-r--m',
    'mr--l',
    'is-clickable',
  ]);

  const goToPDP = (ev) => {
    trackGTMEvents({
      category: 'Interaction',
      action: 'GoToPDP',
      position: 'PGP_Footer',
    }, {}, true);
    loadDetail(ev, uri, false, false, null);
    // window.location.href = uri;
  };

  const clsDtlsBtn = makeClassName([
    cls[`${mainCls}__btn-detail`],
    'tp-w--m',
    'tp-s--l',
    'c-bg--w',
    'mr--s',
    'c-txt--secondary',
    'is-clickable',
  ]);

  return (
    <GridItem className={hdrCls} behavior="fixed">
      <Grid
        className={cls[`${mainCls}__h100`]}
        align={device !== 'smartphone' ? 'center' : null}
      >
        <GridItem
          className={`${cls[`${mainCls}__close`]} ${cls[`${mainCls}__h100`]}`}
          behavior="fixed"
        >
          <button type="button" className={closeBtnCls} onClick={closeModal}>
            <Icon name={CloseIcon} color="secondary" size="m" />
          </button>
        </GridItem>
        <GridItem
          className={`${
            cls[`${mainCls}__utils-title`]
          }${' tp-a--r tp-s--l tp-w--l c-txt--f0'}`}
        >
          {slider.length > 1 ? (
            <>
              Planimetria {activeMedia + 1} di {slider.length}
            </>
          ) : (
            <>Planimetria</>
          )}
        </GridItem>
        <div className={`${cls[`${mainCls}__ghost-el`]}`}></div>
        <Grid className={`${cls[`${mainCls}__utils`]}`} direction="column">
          <button
            type="button"
            onClick={(ev) => goToPDP(ev)}
            className={clsDtlsBtn}
            bg="w"
            border="b-r--m"
          >
            Dettagli immobile
            <Icon name={Caret} width="14px" className="ml--xs is-rot-270" />
          </button>
          <button
            type="button"
            className={leadBtnCls}
            onClick={() => callOpenSpecificModal({ forcedPosition: 'PGP_Header'})}
          >
            Contatta
          </button>
        </Grid>
      </Grid>
    </GridItem>
  );
};

export default Header;
